'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var last = require('it-last');
var cid = require('multiformats/cid');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var last__default = /*#__PURE__*/_interopDefaultLegacy(last);

function createAdd({addAll}) {
  return (path, options = {}) => {
    let iter;
    const cid$1 = cid.CID.asCID(path);
    if (cid$1) {
      iter = addAll([{
          cid: cid$1,
          ...options
        }], options);
    } else {
      iter = addAll([{
          path: path.toString(),
          ...options
        }], options);
    }
    return last__default["default"](iter);
  };
}

exports.createAdd = createAdd;
